import { render, staticRenderFns } from "./OfferAdd.vue?vue&type=template&id=5aa61ace&scoped=true&"
import script from "./OfferAdd.vue?vue&type=script&lang=js&"
export * from "./OfferAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa61ace",
  null
  
)

export default component.exports